import { useState } from "react"
import { CTaxPropertySelect, MainPageTitle, PageExplainer } from "./EpimsStyledComponents"

function AddressPicker({userClicksAddress, setMaxCompletedStep}) {

    const [postcode, setPostcode] = useState('')
    const [searchDone, setSearchDone] = useState(false)
    const [searchGood, setSearchGood] = useState(false)
    const [addressList, setAddressList] = useState([])
    const reportPropertyAddress = 'later'

    const doPostcodeSearch = () => {
        setMaxCompletedStep(1)
        const url = process.env.REACT_APP_API_END_POINT + 'epcpostcode'
        fetch(url, {
            headers: {
            'Accept': 'application/json',
            },
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
                "postcode": postcode
            })
        })
        .then((resp) => resp.json())
        .then((data) => {
            console.log(data)
            setSearchDone(true)
            setAddressList(data.addresses ?? [])
            setSearchGood(data.success ?? false)
        });
    }

    const handlePostcodeUpdate = (val) => {
        setPostcode(val)
        setSearchDone(false)
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            doPostcodeSearch()
        }
    }

    return (
        <div style={{maxWidth: "800px", marginInline: "auto", display: "flex", flexDirection: "column", marginTop: "32px"}}>
            <MainPageTitle>Find EPC Certificate</MainPageTitle>
            <PageExplainer>
                epIMS can query the EPC Register and create a report from an already lodged EPC. Please enter a postcode to search the EPC register:
            </PageExplainer>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                <input type="text" size="10" value={postcode} placeholder="SW1 1AA" onChange={e => handlePostcodeUpdate(e.target.value)} onKeyDown={handleKeyDown} />
                <button className="btn btn-primary" style={{marginLeft: "16px"}} onClick={doPostcodeSearch}>Find properties at this postcode</button>
            </div>
            {searchDone && searchGood && <div style={{marginTop: "16px"}}>
                <p>The following EPC certificates were found at this postcode. A property may be listed more than once if it has multiple EPC certificates issued, please check the certificate issue date.</p>
                <p>Please select a certificate to generate a report.</p>
                {
                    addressList.map((entry) => { return (
                        <CTaxPropertySelect className={entry.address === reportPropertyAddress ? 'selected' : ''} onClick={(e) => userClicksAddress(entry)}>
                            <span style={{float: "left", padding: "4px"}}>{entry.address}</span><span style={{float: "right", minWidth: "210px", backgroundColor: "#C0C0FF", padding: "4px", marginLeft: "10px"}}>Band: <strong>{entry.band}</strong>, Date: <strong>{entry.date}</strong></span>
                        </CTaxPropertySelect>
                    )})
                }
            </div>}
            {searchDone && !searchGood && <div style={{marginTop: "16px"}}>
                <span style={{backgroundColor: "red", padding: "2px"}}>No EPCs found at this postcode.</span>
            </div>}
            {searchDone && <div style={{marginTop: "16px"}}>
                <p style={{marginBottom: "0"}}>If the EPC you are looking for is not listed and was only recently lodged, please try again in a day or so.</p>
            </div>}
        </div>
    )
}

export default AddressPicker;